import UpdateRocketSeries from "../../components/addRocketSeries";
import * as Styled from "./styled";
import Sidemenu from "../../components/sidemenu";

const AddTraining = () => {
  return (
    <Styled.MainDiv>
      <Sidemenu />
      <Styled.ColumnDiv>
        <UpdateRocketSeries  type={"EDIT"}/>
      </Styled.ColumnDiv>
    </Styled.MainDiv>
  );
};

export default AddTraining;
